var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          ref: "directUpload",
          attrs: {
            action: "#",
            limit: 1,
            "file-list": _vm.fileList,
            "show-file-list": _vm.showFileList,
            "http-request": _vm.uploadRequest,
            "before-upload": _vm.beforeUpload,
            "on-remove": _vm.handleRemove,
            accept: _vm.accept,
            "on-exceed": _vm.handleExceed,
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "upLoad-pic-box",
              style: { width: _vm.width, height: _vm.height },
            },
            [
              _vm.imgUrl
                ? _c(
                    "div",
                    {
                      staticClass: "flex-center-row img-box",
                      style: { width: _vm.width, height: _vm.height },
                    },
                    [
                      _c("img", {
                        staticClass: "img",
                        attrs: { src: _vm.imgUrl, alt: "image" },
                      }),
                      _c(
                        "div",
                        { class: ["upload-mask", "upload-mask-bgColor"] },
                        [
                          _c("i", {
                            staticClass: "el-icon-delete delete-icon",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleRemove()
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass: "img-box",
                      style: { width: _vm.width, height: _vm.height },
                    },
                    [
                      _vm.defaultImgUrl
                        ? _c("img", {
                            staticClass: "img",
                            attrs: { src: _vm.defaultImgUrl, alt: "add" },
                          })
                        : _c("i", { staticClass: "el-icon-plus" }),
                    ]
                  ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }